import { Typography } from '@mui/material';
import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css'
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    container: {
        '& .special-label': {
            fontSize: '12px!important',
            color: '#0009!important'
        },
    },
}));

function PhoneNumber(props) {
    const classes = useStyles();
    const { value, onChange } = props;
    const [selectedCountry, setSelectedCountry] = useState('us');

    const handleCountryChange = (phone, country) => {
        setSelectedCountry(country ? country.countryCode : 'us');
        onChange(phone);
    };

    const handleInputChange = (phone, country) => {
        if (phone.trim() === '') {
            setSelectedCountry('us');
            phone = '+1';
        }
        if(country.countryCode !== 'ca'){
            handleCountryChange(phone, country);
        }else{ 
            onChange(phone); 
        } 
    };

    return (
        <React.Fragment>
            <PhoneInput
                country={selectedCountry}
                onEnterKeyPress={() => setSelectedCountry('')}
                inputStyle={{
                    height: '40px',
                    width: '100%',
                    border: props.error ? '1px solid red' : '1px solid #ccc',
                    backgroundColor: props.error ? '#FAF0F0' : 'white',
                    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                    fontWeight: 400,
                    fontSize: '1rem',
                    lineHeight: '1.4375em',
                    letterSpacing: '0.00938em',
                    // zIndex: 0,
                    // '.special-label': {
                    //             zIndex: 0,
                    //         },    
                }}
                // containerStyle={{
                //     '.special-label': {
                //         fontSize: '12px',
                //     },
                // }}
                specialLabel={props.label ? (props.label + (props.required ? ' *' : '')) : ("Phone Number" + (props.required ? ' *' : ''))}
                className={`react-tel-input ${classes.container}`}
                name={props.name}
                placeholder={props.placeholder}
                disabled={props.disabled}
                value={value}
                onChange={handleInputChange}
                inputProps={{
                    name: props.name,
                    required: props.required,
                }}
                isValid={(value, country) => {
                    if (props.error) {
                        if (value === '') {
                            return false;
                        } else if (value.match(/12345/)) {
                            return 'Invalid value: ' + value + ', ' + country.name;
                        } else if (value.match(/1234/)) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                }}
            />
            {props.error && (
                <Typography
                    sx={{
                        color: '#d32f2f',
                        fontWeight: '400',
                        fontSize: '0.75rem',
                        ml: 2,
                        mt: '4px',
                        lineHeight: '1.66',
                        letterSpacing: '0.03333em',
                        textAlign: 'left',
                        marginTop: '4px',
                        marginRight: '14px',
                        marginBottom: '0',
                        marginLeft: '14px',
                    }}
                >
                    {props.helperText.length > 0 ? props.helperText : ''}
                </Typography>
            )}
        </React.Fragment>
    );
}

export default PhoneNumber;
